import { api } from './client';
import { resetCsrfToken } from './csrf';

export async function changePassword(request: {
  current_password: string;
  new_password: string;
}): Promise<void> {
  await api.post<unknown>('/account/password', request);
  // The server rotates the session id on success; drop any cached CSRF token with it.
  resetCsrfToken();
}
